import { makeStyles } from 'tss-react/mui'
import { darkBg } from '../../../assets/colors'


const useStyles = makeStyles()((theme) => ({
    root: {
        height: '15px',
        width: '15px',
        minWidth: '15px',
        borderRadius: '2px',
        padding: 0,
        '&:hover': {
            backgroundColor: 'currentColor'
        },
        position: 'relative'
    },
    selected: {
        '&::after': {
            content: '\"\"',
            display: 'block',
            height: 'calc(100% + 4px)',
            width: 'calc(100% + 4px)',
            border: `1px solid ${theme.palette.mode === "dark" ? '#fff': darkBg}`,
            position: 'absolute',
            pointerEvents: 'none',
            top: '-2px',
            left: '-2px',
            boxSizing: 'border-box'
        }
    }
}))

export default useStyles